import styled from "styled-components"

export const Container = styled.div`
  display: ${({ show }) => (!!show ? "grid" : "none")};
`
